import { network } from 'services/network';
import { useQuery } from 'react-query';
import {
    IActivitiesSummaryResponse,
    IGanttChartPayload,
    IGanttChartResponse,
} from 'components/widgets/Gantt/components/ganttChart.types';

const getActivities = (params) => {
    return network
        .post('api/bo/getGantActivitiesGraph', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const getActivitiesSummary = (params) => {
    const url = `api/bo/getActivitiesSummary?metaDataId=${params}`;
    return network
        .get(url)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const useQueryGanttChart = (params: IGanttChartPayload | null) => {
    return useQuery<IGanttChartResponse, QueryError>(['ganttChartActivities', params], () => getActivities(params), {
        enabled: Boolean(params?.id) && typeof params?.maxLevel === 'number' && typeof params?.minLevel === 'number',
        placeholderData: {
            activities: [],
            info: {
                infoList: '',
                link: '',
            },
            versionDate: 0,
        },
    });
};

const useQueryActivitiesSummary = (params?: number) => {
    return useQuery<IActivitiesSummaryResponse, QueryError>(
        ['activitiesSummary', params],
        () => getActivitiesSummary(params),
        {
            enabled: typeof params === 'number',
        },
    );
};

export { useQueryGanttChart, useQueryActivitiesSummary };
